module.exports = __webpack_public_path__ + "static/media/paint-palette.e02304de.svg";